// // src/components/HeroSection.js
// import React from "react";
// import yogaImage from "../../assets/WebBennerSquare.png";
// import { Link } from "react-router-dom";

// const HeroSection = () => {
//   return (
//     <section className="relative w-full bg-gradient-to-b from-[#d0d9e5] to-white py-12 lg:py-20">
//       <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
//         {/* Left: Text */}
//         <div className="text-center lg:text-left max-w-2xl">
//           <h1 className="text-3xl lg:text-6xl font-extrabold text-gray-900 leading-snug">
//             Revibe Your Fitness, Anytime Anywhere
//           </h1>
//           <p className="mt-4 text-lg text-gray-700">
//             Affordable online workouts with expert trainers—designed for busy
//             people who want results.
//           </p>

//           {/* CTA Button */}
//           <div className="mt-6">
//             <Link
//               to="/pricing"
//               className="inline-block hover:bg-[#b8ea03] bg-[#C5F122] text-gray-800 font-semibold px-6 py-3 rounded-lg shadow-lg transition"
//             >
//               Get Started →
//             </Link>
//           </div>

//           {/* Trusted Users */}
//           <div className="mt-6 flex items-center justify-center lg:justify-start">
//             <div className="flex -space-x-3">
//               <img
//                 src="https://randomuser.me/api/portraits/women/1.jpg"
//                 alt="user1"
//                 className="w-10 h-10 rounded-full border-2 border-white"
//               />
//               <img
//                 src="https://randomuser.me/api/portraits/men/2.jpg"
//                 alt="user2"
//                 className="w-10 h-10 rounded-full border-2 border-white"
//               />
//               <img
//                 src="https://randomuser.me/api/portraits/women/3.jpg"
//                 alt="user3"
//                 className="w-10 h-10 rounded-full border-2 border-white"
//               />
//             </div>
//             <span className="ml-3 text-gray-800 text-sm">
//               Trusted by 1.24 Crore+ Global members
//             </span>
//           </div>
//         </div>

//         {/* Right: Image */}
//         <div className="flex justify-center lg:justify-end mt-8 lg:mt-0">
//           <img
//             src={yogaImage}
//             alt="Yoga Habit Program"
//             className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;


// src/components/HeroSection.js
import React, { useState } from "react";
import yogaImage from "../../assets/WebBennerSquare.png";
import Login from "../Login"; // ← path adjust કરો

const HeroSection = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  return (
    <>
      {/* Login Modal */}
      <Login
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onOpenRegister={() => setIsLoginOpen(false)}
      />

      <section className="relative w-full bg-gradient-to-b from-[#d0d9e5] to-white py-12 lg:py-20">
        <div className="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Left: Text */}
          <div className="text-center lg:text-left max-w-2xl">
            <h1 className="text-3xl lg:text-6xl font-extrabold text-gray-900 leading-snug">
              Revibe Your Fitness, Anytime Anywhere
            </h1>
            <p className="mt-4 text-lg text-gray-700">
              Affordable online workouts with expert trainers—designed for busy
              people who want results.
            </p>

            {/* CTA Button - Link ને button માં બદલ્યું */}
            <div className="mt-6">
              <button
                onClick={() => setIsLoginOpen(true)}
                className="inline-block hover:bg-[#b8ea03] bg-[#C5F122] text-gray-800 font-semibold px-6 py-3 rounded-lg shadow-lg transition"
              >
                Get Started →
              </button>
            </div>

            {/* Trusted Users */}
            <div className="mt-6 flex items-center justify-center lg:justify-start">
              <div className="flex -space-x-3">
                <img
                  src="https://randomuser.me/api/portraits/women/1.jpg"
                  alt="user1"
                  className="w-10 h-10 rounded-full border-2 border-white"
                />
                <img
                  src="https://randomuser.me/api/portraits/men/2.jpg"
                  alt="user2"
                  className="w-10 h-10 rounded-full border-2 border-white"
                />
                <img
                  src="https://randomuser.me/api/portraits/women/3.jpg"
                  alt="user3"
                  className="w-10 h-10 rounded-full border-2 border-white"
                />
              </div>
              <span className="ml-3 text-gray-800 text-sm">
                Trusted by 1.24 Crore+ Global members
              </span>
            </div>
          </div>

          {/* Right: Image */}
          <div className="flex justify-center lg:justify-end mt-8 lg:mt-0">
            <img
              src={yogaImage}
              alt="Yoga Habit Program"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;